import { render } from "./SyllabusMaster.vue?vue&type=template&id=5a32bda5&scoped=true"
import script from "./SyllabusMaster.vue?vue&type=script&lang=js"
export * from "./SyllabusMaster.vue?vue&type=script&lang=js"

import "./SyllabusMaster.vue?vue&type=style&index=0&id=5a32bda5&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a32bda5"]])

export default __exports__